import React from "react";
import { SkeletonProps } from "./props";
import MUISkeleton from "@mui/material/Skeleton";

export const Skeleton: React.FC<SkeletonProps> = ({ width, height }) => {
  return <MUISkeleton variant="rectangular" width={width} height={height} />;
};
